enum FrequentlyUsedField {
    /** 打印状态 */
    PRINT_STATUS = "PRINT_STATUS",
    /** 物流信息 */
    LOGISTICS_INFO_STATUS = "LOGISTICS_INFO_STATUS",
    /** 物流停滞时间 */
    LOGISTICS_STAGNANT_HOURS = "LOGISTICS_STAGNANT_HOURS",
    /** 剩余发货时间 */
    REMAINING_SHIPPING_HOURS = "REMAINING_SHIPPING_HOURS",
    /** 快捷选单 */
    QUICK_CRITERION = "QUICK_CRITERION",
    /** 买家昵称 */
    BUYER_USERNAME = "BUYER_USERNAME",
    /** 订单编号 */
    ORDER_ORIGINAL_ID = "ORDER_ORIGINAL_ID",
    /** 不可达 */
    UNDELIVERABLE_AREA = "UNDELIVERABLE_AREA",
    /** 快递分区  (前端的组件时ShippingArea) */
    SHIPPING_ADDRESS = "SHIPPING_ADDRESS",
    /** 旗帜颜色 */
    SELLER_FLAG = "SELLER_FLAG",
    /** 运单号 */
    WAYBILL_NO = "WAYBILL_NO",
    /** 收货人 */
    CONSIGNEE_NAME = "CONSIGNEE_NAME",
    /** 手机电话 */
    CONSIGNEE_PHONE = "CONSIGNEE_PHONE",
    /** 商品名称 */
    ORDER_ITEM_TITLE = "ORDER_ITEM_TITLE",
    /** 商品属性 */
    SKU_PROPERTIES = "SKU_PROPERTIES",
    /** 商品ID */
    PRODUCT_ORIGINAL_ID = "PRODUCT_ORIGINAL_ID",
    /** SKU ID */
    SKU_ORIGINAL_ID = "SKU_ORIGINAL_ID",
    /** 商品编码 */
    ORDER_ITEM_EXTERNAL_ID = "ORDER_ITEM_EXTERNAL_ID",
    /** 商品状态 */
    ITEM_STATUSES = "ITEM_STATUSES",
    /** 收货人省市区 */
    CONSIGNEE_AREA = "CONSIGNEE_AREA",
    /** 收货人街道 */
    CONSIGNEE_STREET = "CONSIGNEE_STREET",
    /** 快递公司 */
    LOGISTICS_COMPANY = "LOGISTICS_COMPANY",
    /** 买家留言 */
    BUYER_REMARKS = "BUYER_REMARKS",
    /** 卖家备注 */
    SELLER_REMARKS = "SELLER_REMARKS",
    /** 商品数量范围 */
    QUANTITY_RANGE = "QUANTITY_RANGE",
    /** 实付金额范围 */
    PAYMENT_AMOUNT_RANGE = "PAYMENT_AMOUNT_RANGE",
    /** 重量范围 */
    WEIGHT_RANGE = "WEIGHT_RANGE",
    /** 商品货位 */
    STOCK_NO = "STOCK_NO",
    /** 发货人 */
    SHIPPER = "SHIPPER",
    /** 包含标签 */
    ORDER_TAG = "ORDER_TAG",
    /** 不含标签 */
    EXCLUDED_ORDER_TAG = "EXCLUDED_ORDER_TAG",
    /** 订单标记 */
    ORDER_MARK = "ORDER_MARK",
    /** 带货达人 */
    AFFILIATE_MARKETER = "AFFILIATE_MARKETER",
    /** 批次号 */
    PRINT_BATCH_NO = "PRINT_BATCH_NO",
    /** 供货商 */
    SUPPLIER = "SUPPLIER",
    /** 代理商 */
    RETAILER = "RETAILER",
    /** 订单时间范围 */
    ORDER_TIME_RANGE = "ORDER_TIME_RANGE",
}

export default FrequentlyUsedField;
